@if (!isButton()) {
  <a [href]="queryUrl" target="_blank" class="text-gray-600 text-hover-primary">
    <ng-content></ng-content>
  </a>
} @else {
  <ui-button
    [size]="'sm'"
    [outline]="true"
    [icon]="icon()"
    [severity]="'light'"
    [buttonText]="buttonText()"
    [href]="queryUrl"
  ></ui-button>
}
